export default __webpack_public_path__ + "static/media/other.dfee066f.svg";